import { appRoutes, isInTwoFactorAuthenticationLoginFlow } from '#services';
export const inviteLandingRoutePredicate = ({ currentUser, }) => {
    if (isInTwoFactorAuthenticationLoginFlow(currentUser)) {
        return { isSuccess: false, navigateTo: appRoutes.login() };
    }
    if (!currentUser) {
        return { isSuccess: true };
    }
    if (Boolean(currentUser) && !currentUser.emailVerified) {
        return { isSuccess: false, navigateTo: appRoutes.verifyEmail() };
    }
    return {
        isSuccess: true,
    };
};
